type SeoProps = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

const SITE_ORIGIN = "https://tn8v0ac.cn";

export default function Seo({
  title,
  description,
  keywords,
  path,
  ogType = "website",
  jsonLd,
}: SeoProps) {
  const canonical = `${SITE_ORIGIN}${path === "/" ? "" : path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <meta name="theme-color" content="#ffffff" />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="瓜友会网" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {jsonLd ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      ) : null}
    </>
  );
}